import { createClassName } from 'utils/createClassName';

import './dashboardTableStyles.scss';

export const createDashboardTableClassName = createClassName('dashboard-table');
